import gsap, { SplitText,ScrollTrigger,DrawSVGPlugin } from "gsap/all";
gsap.registerPlugin(SplitText,ScrollTrigger,DrawSVGPlugin);

export default [
    {
        name: "fadeIn",
        callback: (el, params, observerDelegate) => {
            switch(params.dir||'none'){
                case 'left': gsap.set(el, { opacity: 0,xPercent:10 });break;
                case 'right': gsap.set(el, { opacity: 0,xPercent:-10 });break;
                case 'bottom': gsap.set(el, { opacity: 0,yPercent:-25 });break;
                case 'top': gsap.set(el, { opacity: 0,yPercent:25 });break;
                default: gsap.set(el, { opacity: 0 });
            }
           
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                switch(params.dir||'none'){
                    case 'left': gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1, delay:params.delay ?? 0 });break;
                    case 'right': gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1, delay:params.delay ?? 0 });break;
                    case 'bottom': gsap.to(el, { opacity: 1,yPercent:0, duration: params.duration ?? 1, delay:params.delay ?? 0 });break;
                    case 'top': gsap.to(el, { opacity: 1,yPercent:0, duration: params.duration ?? 1, delay:params.delay ?? 0 });break;
                    default: gsap.to(el, { opacity: 1, duration: params.duration ?? 1, delay:5});break;
                }
                gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1,delay:params.delay ?? 0  })
            })
        }
    },
    {
        name: "slideIn",
        callback: (el, params, observerDelegate) => {
            switch(params.dir||'none'){
                case 'left': gsap.set(el, { opacity: 1,xPercent:10 });break;
                case 'right': gsap.set(el, { opacity: 1,xPercent:-10 });break;
                case 'bottom': gsap.set(el, { opacity: 1,yPercent:-25 });break;
                case 'top': gsap.set(el, { opacity: 1,yPercent:25 });break;
            }
           
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                switch(params.dir||'none'){
                    case 'left': gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1 });break;
                    case 'right': gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1 });break;
                    case 'bottom': gsap.to(el, { opacity: 1,yPercent:0, duration: params.duration ?? 1 });break;
                    case 'top': gsap.to(el, { opacity: 1,yPercent:0, duration: params.duration ?? 1 });break;
                    default: gsap.to(el, { opacity: 1, duration: params.duration ?? 1 });break;
                }
                gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1 })
            })
        }
    },
    {
        name: "revealer", // Affiche un mot ou phrase mot par mot
        callback: (el, params,observerDelegate) => {
            // gsap.set(el, { rotateX: '90deg', 'display': 'inline-block' })
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                const tl = gsap.timeline();
                const split = new SplitText(el, { type: "words,chars" });
                const chars = split.chars;
                tl.from(chars, {
                    duration: 0.15,
                    opacity: 0,
                    yPercent: 25,
                    transformOrigin: "50% 0%",
                    ease: "back",
                    stagger: 0.05
                });
            })
        }
    },
    {
        name:"draw", // Permet de faire une animation avec un svg qui est un path
        callback: (el, params, observerDelegate) => {
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                gsap.from(el, {duration:2,drawSVG: 0,delay:params.delay ?? 0.5});
            })
        }
    },
    {
        name: 'parallax', // Permet de changer la vitesse de scroll d'un élément
        callback: (el, params) => { // les params sont yStart, yEnd 
            let mm = gsap.matchMedia();
  
            mm.add({
                isMobile: "(max-width:768px)",
                isDesktop: "(min-width:769px)"
            }, (context) => {
                let { isMobile, isDesktop } = context.conditions;
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        scrub: params.scrub ?? 1,
                    },
                });
                if(!isMobile){
                    tl.set(el, { transition:'transform 0.1s ease',display: 'inline-block', y: isDesktop ? params.yStart ?? 0 : (params.yStart ?? 0) / 2 });
                    tl.to(el, {
                        y: isDesktop ? params.yEnd ?? 0 : (params.yEnd ?? 0) / 2,
                        ease: params.ease ?? "power1"
                    });
                }
               
            })
        }
    },
    {
        name : 'fadeinchild',
        callback : (el, params,observerDelegate) => {
            const rows = el.querySelectorAll('.cdm-col');
            rows.forEach((el,i)=>{
                gsap.set(el, { opacity: 0});
            });
            observerDelegate.observe(el, () => {
                rows.forEach((el,i)=>{
                    gsap.to(el, { opacity: 1,duration: 1,delay:i * 0.3 })
                })
            });
        }
    }
]